import { ConfirmResultModal } from './ConfirmResultModal'
import { Mtds } from '../..'
import { useState } from 'react'
import type { ResultSet } from '../../types/types'

type ConfirmResultButtonProps = {
  sampleId: string
  requisitionId: number
  resultId: number
  resultStatus: ResultSet['status']
}

export const ConfirmResultButton = ({
  sampleId,
  requisitionId,
  resultId,
  resultStatus
}: ConfirmResultButtonProps) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const isEditing = resultStatus === 'POSITIVE' || resultStatus === 'NEGATIVE'
  return (
    <div>
      <Mtds.Button data-variant={'primary'} onClick={() => setModalOpen(true)}>
        {isEditing ? 'Rediger resultat' : 'Vurder resultat'}
      </Mtds.Button>
      <ConfirmResultModal
        sampleId={sampleId}
        requisitionId={requisitionId}
        resultId={resultId}
        resultStatus={resultStatus}
        isOpen={isModalOpen}
        setOpen={setModalOpen}
      />
    </div>
  )
}
